
import { defineComponent } from 'vue';
import marked from 'marked';
import contentMd from '!raw-loader!./homecontent.txt';

export default defineComponent({
  name: 'Home',
  setup() {
    return {
      content: marked(contentMd),
    };
  },
});
